import React from 'react'
import { useRef, useEffect } from 'react'
import { Flex } from 'theme-ui'

import Heading from '~/components/IntlComponents/Heading'

import Text from '~/components/IntlComponents/Text'
import PropTypes from 'prop-types'
import Product from '~/components/Gift/Product'

const List = ({
  gifts,
  onSelection,
  selected,
  selectionMade,
  noSelectionNedeed,
  errorText,
  title,
  intro,
}) => {
  const errorStyle = {
    color: '#ffffff',
    fontWeight: 'body',
    marginTop: '6px',
    textAlign: 'center',
    padding: '12px 24px',
    backgroundColor: '#FF5A47',
    borderRadius: '4px',
    width: 'fit-content',
    display: 'block',
    margin: '20px auto 0',
    border: '1px solid rgba(255, 255, 255, .25)',
  }

  const productWrapperStyle = {
    justifyContent: 'center',
    flexFlow: ['column', 'wrap'],
    margin: '0 auto 80px',
  }

  const headingStyle = {
    textAlign: 'center',
    color: 'secondary',
    margin: '55px auto 0',
    maxWidth: [250, 700],
  }

  const introStyle = {
    display: 'block',
    textAlign: 'center',
    color: 'tertiary',
    fontFamily: 'Sofia-Pro',
    fontWeight: '200',
    fontSize: [18, 24],
    maxWidth: [340, 490],
    margin: '60px auto 0',
  }

  const ref = useRef(null)

  useEffect(() => {
    errorText &&
      ref.current.scrollIntoView({ behavior: 'smooth', block: 'center' })
  })

  return (
    <>
      <Heading as="h4" sx={headingStyle} variant="h3">
        {title}
      </Heading>
      {!noSelectionNedeed && <Text sx={introStyle}>{intro}</Text>}

      {errorText && (
        <Text sx={errorStyle} ref={ref}>
          {errorText}
        </Text>
      )}

      <Flex sx={productWrapperStyle} my={4}>
        {gifts.map(({ images, sku, name, description, slug, options_text }) => {
          const { alt: imageAlt, small_url } = images[0]
          const alt = imageAlt ?? `image-${sku}`

          return (
            <Product
              alt={alt}
              imageUrl={small_url}
              key={sku}
              name={name}
              optionsText={options_text}
              description={description}
              onSelection={onSelection}
              selected={sku === selected}
              sku={sku}
              selectionMade={selectionMade}
              slug={slug}
            />
          )
        })}
      </Flex>
    </>
  )
}

List.propTypes = {
  gifts: PropTypes.arrayOf(
    PropTypes.shape({
      images: PropTypes.arrayOf(
        PropTypes.shape({
          small_url: PropTypes.string,
          alt: PropTypes.string,
        }),
      ),
      sku: PropTypes.string,
      name: PropTypes.string,
    }),
  ).isRequired,
  onSelection: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  intro: PropTypes.string,
  selected: PropTypes.string,
  errorText: PropTypes.string,
}

export default List
